export const DepositNavTitle = {
  DEPOSIT: "deposit",
  HISTORY: "history",
};

export const SettingNavTitle = {
  PROFILE: "profile",
  DEPOSIT: "deposit",
  WITHDRAW: "withdraw",
  TRANSFER: "transfer",
  MEMBER_TRANSFER: "memberTransfer",
  POINT_SHOP: "pointShop",
  EXCHANGE: "exchange",
  TRANSACTION_REPORT: "transactionReport",
  GAME_REPORT: "gameReport",
  INBOX: "inbox",
  BONUS: "bonus",
};

export const PaymentMethod = {
  ATM: "atm",
  PAYMENT_GATEWAY: "paymentGateway",
  TELCO: "telco",
};

export const PaymentMethodNavConst = [
  {
    title: PaymentMethod.ATM,
    image: "image/atm.avif?312254345",
  },
  {
    title: PaymentMethod.PAYMENT_GATEWAY,
    image: "image/paymentgateway.avif?8998745464",
  },
  {
    title: PaymentMethod.TELCO,
    image: "image/telcopayment.avif?415648451",
  },
];
